import { useState, useEffect } from 'react';
import { subscribeProperty } from '../services/utils';

const BASE_OFFSET = 60;

const useRestHeight = containerRef => {
  const [height, setHeight] = useState(0);

  const resizeHeight = () => {
    const screenH = document.body.clientHeight;
    const rest = screenH - containerRef.current.offsetTop - BASE_OFFSET;
    setHeight(rest);
  };

  useEffect(() => {
    resizeHeight();

    const unsubscribe = subscribeProperty(
      resizeHeight,
      containerRef.current,
      'offsetTop',
    );

    return unsubscribe;
  }, [containerRef]);

  return height;
};

export default useRestHeight;
